/**
 * This module dynamically alters the viewport depending on the device width.
 * This optimizes the mobile experience.
 * 
 * Note: does not work in Firefox for Andorid
 * Will be eventually replaced by @viewport which is only supported by Opera and IE for now.
 */
define('responsive',[], function() {
	function updateViewport() {
		// These numbers occur in css/layout.less, helpers/html_helper.php and js/responsive.js
		if ((typeof screen == 'object') && ('availWidth' in screen) && screen.availWidth <= 1020) {
			var metaTag = $('meta[name=viewport]');
			var width;
			if (screen.availWidth <= 786)
				width = 510;
			else
				width = 745;
			
			if (!metaTag.length)
				metaTag = $('<meta name="viewport">').appendTo($('head'));
			
			metaTag.attr('content', 'width=' + width);
			metaTag.attr('zoom', '1');
		} else {
			$('meta[name=viewport]').remove();
		}
	}
	
	updateViewport();
	$(window).resize(updateViewport);
});

